import { cva } from '@/styled-system/css';

export const alertIconRecipe = cva({
  base: {
    flex: '0 0 auto',
    marginInlineEnd: 'Alert.gap.leading',
  },
  variants: {
    tone: {
      info: { color: 'Alert.info.icon' },
      critical: { color: 'Alert.critical.icon' },
      success: { color: 'Alert.success.icon' },
      warning: { color: 'Alert.warning.icon' },
    },
  },
});
